import { getVerbisLebenslaufStatus, lebenslaufZeilenOffen } from '../api/verbisLebenslauf'

export async function verbisLebenslaufFehlt(coachingId: string): Promise<boolean> {
  const status = await getVerbisLebenslaufStatus(coachingId)
  return status.verbis === null || status.lebenslauf === null || lebenslaufZeilenOffen(status.lebenslauf.ohne_datum)
}
